"use strict";

import {parseBoolean} from "./calculator/helpers/calculator-helpers";
import loadLanguage from "./language";

const captchaPublicKey = $('meta[name="captchaPublicKey"]').prop('content');
const disableCaptcha = parseBoolean($('meta[name="disableCaptcha"]').prop('content'));
const registerUrl = $('meta[name="registerUrl"]').prop('content');

$(() => {
    $('#registerForm').submit((event) => {
        event.preventDefault();
        if (!controller.validate_age()) {
            controller.open_dialog('dobRequiredModal');
            return;
        }

        if (!disableCaptcha) {
            // https://developers.google.com/recaptcha/docs/verify
            grecaptcha.ready(() => grecaptchaReady(event));
        } else {
            submit(event);
        }
    });
    const appProduct = $('meta[name="appProduct"]').prop('content');
    const viewName = $('meta[name="viewName"]').prop('content');
    const langCode = $('meta[name="langCode"]').prop('content');
    const partnerSubdomain = $('meta[name="partnerSubdomain"]').prop('content');
    const language = loadLanguage(appProduct, viewName, langCode, partnerSubdomain);
    const occupations = language.occupation_option;

    const $occupation = $('#occupation_select');

    $occupation.empty();

    const blank = new Option('-', '', true);
    blank.disabled = false;
    $occupation.append(blank);

    occupations.forEach((occupation) => {
        $occupation.append(new Option(occupation, occupation, false));
    });
});

function submit(event) {
    const formData = $('#registerForm').serializeArray();
    $('.invalid-feedback').children('strong').text('');
    $('#registerForm input').removeClass('is-invalid');


    $.ajax({
        method: 'POST',
        headers: {
            Accept: 'application/json'
        },
        url: registerUrl,
        data: formData,
        success: (response) => {
            if (!disableCaptcha) {
                grecaptcha.reset();
            }
            if (response.partner) {
                const redirectUrl = [
                    window.location.protocol, "//",
                    response.partner.subdomain,
                    ".", window.baseDomain,
                    '/assignID/',
                    response.user, "/",
                    response.tempID
                ].join('');

                window.location.replace(redirectUrl);
            } else {
                window.location.replace('/assignID');
            }
        },
        error: (response) => {
            if (!disableCaptcha) {
                grecaptcha.reset();
            }
            if (response.status === 422) {
                const errors = response.responseJSON.errors;
                Object.keys(errors).forEach((key) => {
                    $('#' + key + 'Input').addClass('is-invalid');
                    $('#' + key + 'Error').children('strong').text(errors[key][0]);
                });
            } else {
                window.location.reload();
            }
        }
    });
}

if (!disableCaptcha) {
    function grecaptchaReady(event) {
        // v2
        const token = grecaptcha.getResponse();
        grecaptchaResponseSubmit(event, token);
    }

    function grecaptchaResponseSubmit(event, token) {
        // Easy and lazy way to add captcha token to response by letting serializeArray handle it below
        $('#captcha').val(token);
        submit(event);
    }

    function grecaptchaLoad() {
        grecaptcha.render(
            'captchaBox',
            {sitekey: captchaPublicKey}
        );
    }
}
